/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Invitation_Already_PendingInputs */

const en_us2_group_invitation_already_pending = /** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is already a live invitation for this email.`)
};

const pt_br2_group_invitation_already_pending = /** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe um convite ativo para esse email.`)
};

const pt_pt2_group_invitation_already_pending = /** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe um convite ativo para esse email.`)
};

/** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */
const es_419_group_invitation_already_pending = en_us2_group_invitation_already_pending;

/** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */
const fr_fr2_group_invitation_already_pending = en_us2_group_invitation_already_pending;

/** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */
const de_de2_group_invitation_already_pending = en_us2_group_invitation_already_pending;

/** @type {(inputs: Group_Invitation_Already_PendingInputs) => LocalizedString} */
const it_it2_group_invitation_already_pending = en_us2_group_invitation_already_pending;

/**
* | output |
* | --- |
* | "There is already a live invitation for this email." |
*
* @param {Group_Invitation_Already_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_invitation_already_pending = /** @type {((inputs?: Group_Invitation_Already_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Invitation_Already_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_invitation_already_pending(inputs)
	if (locale === "es-419") return es_419_group_invitation_already_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_group_invitation_already_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_group_invitation_already_pending(inputs)
	if (locale === "de-DE") return de_de2_group_invitation_already_pending(inputs)
	if (locale === "it-IT") return it_it2_group_invitation_already_pending(inputs)
	return en_us2_group_invitation_already_pending(inputs)
});
export { group_invitation_already_pending as "group.invitation_already_pending" }